'use client'

import UIFlex from '@components/ui/UIFlex'
import UIImage from '@components/ui/UIImage'
import UILink from '@components/ui/UILink'
import UIText from '@components/ui/UIText'
import { Box } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'

interface AuthorItemProps {
	src: string
	href: string
	name: string
	position: string
	isDark?: boolean
}
const AuthorItem = ({ src, href, name, position, isDark }: AuthorItemProps) => {
	return (
		<UILink href={href} display="block" className="author-item">
			<UIFlex
				flexDirection="row"
				alignItems="center"
				sx={{
					'&>*:not(:first-child)': {
						marginLeft: pxToRem(8),
					},
				}}
			>
				<Box width={pxToRem(28)} overflow="hidden" borderRadius="9999px">
					<UIImage ratio={1} src={src} alt="" />
				</Box>
				<UIText
					fontWeight={500}
					sx={{
						'&, .MuiTypography-root': {
							color: isDark ? color.colWhite : color.colBlack,
							fontSize: pxToRem(15),
							lineHeight: pxToRem(22),
						},
					}}
				>
					<UIText fontWeight={600}>
						{name} {position}
					</UIText>
				</UIText>
			</UIFlex>
		</UILink>
	)
}

export default AuthorItem
